const ensureCharlieProductVariantIds = (root = document) => {
  root.querySelectorAll('product-info[data-default-variant-id]').forEach((productInfo) => {
    const defaultVariantId = productInfo.dataset.defaultVariantId;
    if (!defaultVariantId) return;

    productInfo.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach((input) => {
      if (!input.value) {
        input.value = input.dataset.defaultVariantId || defaultVariantId;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });
};

document.addEventListener('submit', (event) => {
  const form = event.target.closest?.('form[action*="/cart/add"]');
  if (!form) return;
  const productInfo = form.closest('product-info[data-default-variant-id]');
  const variantInput = form.querySelector('input[name="id"]');
  if (productInfo && variantInput && !variantInput.value) {
    variantInput.value = variantInput.dataset.defaultVariantId || productInfo.dataset.defaultVariantId;
  }
}, true);

document.addEventListener('DOMContentLoaded', () => {
  ensureCharlieProductVariantIds();

  document.querySelectorAll('[data-store-finder]').forEach((finder) => {
    const form = finder.querySelector('[data-store-search]');
    const input = finder.querySelector('[data-store-input]');
    const status = finder.querySelector('[data-store-status]');
    const cards = Array.from(finder.querySelectorAll('[data-partner]'));
    if (!form || !input || !status || !cards.length) return;

    const update = (rawQuery) => {
      const query = rawQuery.trim();
      const normalized = query.toLowerCase();
      const queryTokens = normalized.split(/[\s,]+/).filter((token) => token.length > 1);
      if (/^\d{5}$/.test(normalized)) queryTokens.push(normalized.slice(0, 3));
      let visible = 0;
      cards.forEach((card) => {
        const markets = card.dataset.markets || '';
        const matched = !normalized || markets.includes(normalized) || queryTokens.some((token) => markets.includes(token));
        card.hidden = !matched;
        if (matched) visible += 1;
        const mapLink = card.querySelector('[data-maps-link]');
        if (mapLink) mapLink.href = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${card.dataset.partner} near ${query || 'Midwest'}`)}`;
      });
      if (normalized && visible === 0) {
        cards.forEach((card) => { card.hidden = false; });
        status.textContent = `We don’t have an exact market match for ${query} yet—here are all current retail partners.`;
      } else if (normalized) {
        status.textContent = `Showing partner networks near ${query}. Call ahead for current availability.`;
      } else {
        status.textContent = 'Browse every current retail partner or search a featured market.';
      }
    };

    form.addEventListener('submit', (event) => { event.preventDefault(); update(input.value); });
    finder.querySelectorAll('[data-market]').forEach((button) => button.addEventListener('click', () => {
      input.value = button.dataset.market || '';
      update(input.value);
      finder.querySelector('#store-locator')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }));
  });
});
